$('.mega-menu').on('hover mouseenter',function(){
  $('.mega-menu').removeAttr('open');
  $('.mega-menu').find('summary').attr('aria-expanded','false');
  $(this).attr('open','');
  $(this).find('summary').attr('aria-expanded','true');
});

$('.mega-menu').mouseleave(function() {
  $('.mega-menu').removeAttr('open');
  $('.mega-menu').find('summary').attr('aria-expanded','false');
});

$(document).on("mouseenter",".cc_nav_link",function(e){
    //e.preventDefault();
    $('.mega-menu-parent').removeClass('active');
    $(this).parent('li').addClass("active");
    target = $(this).data("nav");
    collection = $(this).data("cat");
    $(".cc-level-position").hide();
    $(".cc-level-position-2").hide();
    $("div[data-nav='"+target+"']").show();
});

$(document).on("mouseenter",".cc_nav_link_2",function(e){
    //e.preventDefault();
    target = $(this).data("nav2");
    $('.cc_nav_link_2').removeClass('active');
    $(this).addClass("active");
    $(".cc-level-position-2").hide();
    $("div[data-nav='"+target+"']").show();
})



/* Price range slider */
jQuery(document).on('input', '.min-range', function() {
  let minVal = jQuery(this).val();
  //console.log(minVal);
  jQuery('input[name="filter.v.price.gte"]').val(minVal);
});

jQuery(document).on('input', '.max-range', function() {
  let maxVal = jQuery(this).val();
  jQuery('input[name="filter.v.price.lte"]').val(maxVal);
  //console.log(maxVal);
});

jQuery('input[name="filter.v.price.gte"]').on("input", function() {
  let mintextVal = jQuery(this).val();
  jQuery('.min-range').val(mintextVal);
  //console.log(mintextVal);
});

jQuery('input[name="filter.v.price.lte"]').on("input", function() {
  let maxtextVal = jQuery(this).val();
  jQuery('.max-range').val(maxtextVal);
  //console.log(maxtextVal);
});

/* Filter Height */
$( document ).ready(function() {
    if ($(window).width() > 749) {
      var urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has('sort_by')) {
        setTimeout(function(){
         get_filters_height();
        }, 900);
      }
    }
});

function get_filters_height(){
  let height = $(".active-facets.active-facets-desktop").height();
  $("#ProductGridContainer").css("margin-top",height);
}